//lib
import { MDBBtn } from "mdb-react-ui-kit";
import Icon from "../element/icon";
import Image from "../element/image";
import { ExploreMore, WhiteExploreMore } from "../../assets/images";

export default function ArrowButton(props) {
  const { className, color, onClick, exploreMore } = props;

  return (
    <article
      className={`${className ?? ""} common-arrow-button ${color ?? ""}`}
    >
      {exploreMore && <Image src={ExploreMore} className="_img explore-more" />}
      <MDBBtn type="button" onClick={onClick ? onClick : undefined}>
        <Icon icon="humbleicons:arrow-right" />
      </MDBBtn>
    </article>
  );
}
